<template>
  <div>
    <el-popover
      placement="bottom"
      :width="240"
      trigger="click"
      v-model:visible="popShow"
      v-if="type === 'studentAge'"
    >
      <template #reference>
        <el-input
          v-model="model"
          placeholder="请选择"
          @clear="onAgeClear"
          @blur="onSInputBlur"
          clearable
        ></el-input>
      </template>
      <div class="age-content">
        <div class="input-wrap">
          <div class="flex label">
            <span>最小年龄:</span>
            <span class="mg">最大年龄:</span>
          </div>
          <div class="flex align-item-v-center mt-16">
            <div>
              <el-input
                class="input"
                v-model="age.min"
                size="mini"
                type="number"
                @blur="onAgeBlur('min')"
              ></el-input>
            </div>
            <div class="sp">-</div>
            <div>
              <el-input
                class="input"
                v-model="age.max"
                size="mini"
                type="number"
                @blur="onAgeBlur('max')"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="btn-wrap">
          <div>
            <el-button size="mini" @click="popShow = false">取消</el-button>
            <el-button type="primary" size="mini" @click="ageComfirm">确定</el-button>
          </div>
        </div>
      </div>
    </el-popover>
    <el-select
      v-model="model"
      :placeholder="placeholder"
      :filterable="filterable"
      :clearable="clearable"
      :multiple="multiple"
      collapse-tags
      v-else
    >
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import {
  defineComponent, ref, inject, watch,
} from 'vue';

export default defineComponent({
  props: {
    modelValue: {
      type: [String, Array, Number, Object],
    },
    // campus  校区
    // grade  当前公立年级
    // studentStatus  学员状态
    // ldStatus  脸到采集状态
    // bindStatus  小云爱学绑定状态
    // studentAge  学员年龄
    // month 生日月份
    // classStatus 班级状态
    // courseConsumeType 课消类型
    // orderSource  订单来源
    // orderStatus  订单状态
    // productTypes 项目类型
    // courseSignType 点名方式
    // comeFroms 招生来源
    // storeCardStatus 储值卡状态
    // recordType 流水类型
    // archivesType 查询档案记录类型
    // memberScoreType 积分类型
    type: {
      type: String,
      required: true,
    },
    placeholder: String,
    filterable: Boolean,
    clearable: Boolean,
    multiple: Boolean,
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const message = inject('$message');
    const { user, comeFromList } = inject('store');
    const api = inject('api');
    const popShow = ref(false);
    const age = ref({
      min: '',
      max: '',
    });

    // 初始化model值
    const model = (function ___() {
      if (props.type === 'studentAge') {
        const { min, max } = props.modelValue || {};
        age.value.min = min || '';
        age.value.max = max || '';
        if (min && max) {
          return ref(`${min}岁-${max}岁`);
        }
        if (min) {
          return ref(`${min}岁以上`);
        }
        if (max) {
          return ref(`${max}岁以下`);
        }
        return ref('');
      }
      return ref(props.modelValue);
    }());

    // 如果类型是学员年龄，不watch
    if (props.type !== 'studentAge') {
      watch(model, () => {
        emit('update:modelValue', model.value);
      });
      watch(
        () => props.modelValue,
        (nval) => {
          model.value = nval;
        },
      );
    }

    function cr() {
      const gradelist = ref([]);
      const archivesTypeList = ref([]);
      const arr = [
        user.value.campusList,
        // 学员状态
        [{
          id: 0,
          name: '未收费',
        }, {
          id: 1,
          name: '在读',
        }, {
          id: 7,
          name: '停课',
        }],
        gradelist,
        [{
          id: 0,
          name: '未采集',
        }, {
          id: 1,
          name: '已采集',
        }],
        [{
          id: 0,
          name: '未绑定',
        }, {
          id: 1,
          name: '已绑定',
        }],
        [{
          id: 1,
          name: '一月',
        }, {
          id: 2,
          name: '二月',
        }, {
          id: 3,
          name: '三月',
        }, {
          id: 4,
          name: '四月',
        }, {
          id: 5,
          name: '五月',
        }, {
          id: 6,
          name: '六月',
        }, {
          id: 7,
          name: '七月',
        }, {
          id: 8,
          name: '八月',
        }, {
          id: 9,
          name: '九月',
        }, {
          id: 10,
          name: '十月',
        }, {
          id: 11,
          name: '十一月',
        }, {
          id: 12,
          name: '十二月',
        }],
        [{
          id: 0,
          name: '未结班',
        }, {
          id: 1,
          name: '已结班',
        }],
        [{
          id: 0,
          name: '点名课消',
        }, {
          id: 1,
          name: '标记补课',
        }, {
          id: 2,
          name: '点名课消（补课）',
        }, {
          id: 3,
          name: '按天自动计费',
        }, {
          id: 4,
          name: '记课消',
        }],
        [{
          id: 1,
          name: '前台收费',
        }, {
          id: 0,
          name: '网上商城',
        }, {
          id: 2,
          name: '导入订单',
        }],
        [{
          id: 1,
          name: '已付款',
        }, {
          id: 4,
          name: '已作废',
        }],
        [{
          id: 2,
          name: '课程',
        }, {
          id: 1,
          name: '班级',
        }, {
          id: 0,
          name: '物品',
        }, {
          id: 4,
          name: '课时包',
        }, {
          id: 3,
          name: '电子钱包',
        }, {
          id: 5,
          name: '储值卡',
        }],
        [{
          id: 0,
          name: '点名上课',
        }, {
          id: 1,
          name: '标记补课',
        }, {
          id: 2,
          name: '计课消',
        }],
        comeFromList,
        [
          { id: 0, name: '已启用' },
          // { id: 1, name: '停用' },
          { id: 2, name: '已过期' },
        ],
        [
          { id: 10, name: '充值' },
          { id: 11, name: '充值作废' },
          { id: 20, name: '充值退费' },
          { id: 30, name: '购买' },
          { id: 31, name: '购买作废' },
          // { id: 40, name: '课消' },
          // { id: 41, name: '修改课消' },
          // { id: 42, name: '撤销课消' },
          { id: 50, name: '手动扣费' },
          // { id: 51, name: '撤销手动扣费' },
        ],
        archivesTypeList,
        [
          { id: 1, name: '加分' },
          { id: 2, name: '减分' },
        ],
      ];
      let i = 0;
      switch (props.type) {
        case 'campus':
          i = 0;
          break;
        case 'studentStatus':
          i = 1;
          break;
        case 'grade':
          i = 2;
          api.getGradeList().then((res) => {
            gradelist.value.push(
              ...res.data.map((item) => ({
                id: item.dictCode,
                name: item.dictName,
              })),
            );
          });
          break;
        case 'ldStatus':
          i = 3;
          break;
        case 'bindStatus':
          i = 4;
          break;
        case 'birthMonth':
          i = 5;
          break;
        case 'classStatus':
          i = 6;
          break;
        case 'courseConsumeType':
          i = 7;
          break;
        case 'orderSource':
          i = 8;
          break;
        case 'orderStatus':
          i = 9;
          break;
        case 'productTypes':
          i = 10;
          break;
        case 'courseSignType':
          i = 11;
          break;
        case 'comeFroms':
          i = 12;
          break;
        case 'storeCardStatus':
          i = 13;
          break;
        case 'recordType':
          i = 14;
          break;
        case 'archivesType':
          i = 15;
          api.archivesTypePage({
            type: 1,
            page: {
              pageNum: 1,
              pageSize: 999,
            },
          }).then((res) => {
            archivesTypeList.value = res.data;
          });
          break;
        case 'memberScoreType':
          i = 16;
          break;
        default:
          break;
      }
      return {
        list: arr[i],
      };
    }

    function resetAge() {
      if (props.type === 'studentAge') {
        model.value = '';
        emit('update:modelValue', {
          min: '',
          max: '',
        });
      }
    }

    return {
      resetAge,
      model,
      popShow,
      age,
      ...cr(),
      onSInputBlur() {
        const { min, max } = props.modelValue || {};

        if (min && max) {
          model.value = `${min}岁-${max}岁`;
          return;
        }
        if (min) {
          model.value = `${min}岁以上`;
          return;
        }
        if (max) {
          model.value = `${max}岁以下`;
          return;
        }
        model.value = '';
      },
      onAgeBlur(t) {
        if (age.value[t] < 0) {
          age.value[t] = 0;
        }
        if (age.value[t] > 99) {
          age.value[t] = 99;
        }
        if (t === 'min') {
          if (age.value[t] * 1 > age.value.max * 1 && age.value.max * 1 > 0) {
            age.value[t] = age.value.max;
          }
        }
        if (t === 'max') {
          if (age.value[t] * 1 < age.value.min * 1 && age.value.min * 1 > 0) {
            age.value[t] = age.value.min;
          }
        }
      },
      ageComfirm() {
        const a = String(age.value.min).trim();
        const b = String(age.value.max).trim();
        if (a === '' && b === '') {
          message.error('请输入最小年龄或最大年龄');
        } else {
          if (a && b) {
            model.value = `${a}岁-${b}岁`;
            popShow.value = false;
            emit('update:modelValue', {
              min: a * 1,
              max: b * 1,
            });
            return;
          }
          if (a) {
            model.value = `${a}岁以上`;
            popShow.value = false;
            emit('update:modelValue', {
              min: a * 1,
            });
          }
          if (b) {
            model.value = `${b}岁以下`;
            popShow.value = false;
            emit('update:modelValue', {
              max: b * 1,
            });
          }
        }
      },
      onAgeClear() {
        age.value.min = '';
        age.value.max = '';
        emit('update:modelValue', null);
      },
    };
  },
});
</script>

<style lang="scss">
.age-content {
  .input {
    .el-input__inner {
      padding-right: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.align-item-v-center {
  align-items: center;
}
.mt-16 {
  margin-top: 16px;
}
.mg {
  margin-left: 53px;
}
.age-content {
  margin: -12px;
  .input-wrap {
    padding: 18px 24px 40px 24px;
    .input {
      width: 88px;
      .el-input__inner {
        padding-right: 0;
      }
    }
    .sp {
      color: var(--g1);
      font-size: 12px;
      margin: 0 3px;
    }
    .label {
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
    }
  }
  .btn-wrap {
    padding: 8px 24px;
    border-top: 1px solid var(--g6);
    display: flex;
    justify-content: flex-end;
  }
}
</style>
